import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  Tooltip,
} from "recharts";

export default function AnalyticsChart({ chartData = [] }) {
  return (
    <div className="bg-white rounded-2xl shadow-sm p-6">
      <h2 className="text-xl font-bold mb-5">
        Recruitment Analytics
      </h2>

      <ResponsiveContainer width="100%" height={320}>
        <AreaChart data={chartData}>
          <XAxis dataKey="month" />
          <Tooltip />
          
          {/* Candidates wala graph */}
          <Area
            type="monotone"
            dataKey="candidates"
            name="Candidates"
            stroke="#000000"
            fill="#000000"
            fillOpacity={0.1}
          />

          {/* Jobs wala graph */}
          <Area
            type="monotone"
            dataKey="jobs"
            name="Jobs"
            stroke="#FED547"
            fill="#FED547"
            fillOpacity={0.6}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}